import React from "react";

export default function renderIcon({
  width = 24,
  height = 24,
  color = "#495057",
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2364_4031)">
        <path
          d="M18.0126 5.24626C17.6547 5.65385 17.538 6.25307 17.8454 6.72034C18.0809 7.07828 18.4886 7.27466 18.6796 7.66878C18.9426 8.21186 18.652 8.92308 18.0337 9.0399C17.915 9.06239 18.0226 8.92323 18.0444 8.88529C18.1209 8.7521 18.1883 8.60951 18.2181 8.45788C18.2762 8.16298 18.1328 7.84114 17.9709 7.59993C17.9082 7.50653 17.8368 7.42184 17.7663 7.33425C17.5673 7.08517 17.4102 6.79844 17.3746 6.4773C17.3404 6.16724 17.4258 5.85657 17.599 5.59862C17.6717 5.49021 17.757 5.39084 17.8535 5.30287C17.8895 5.26997 17.9266 5.23799 17.966 5.20931C17.9931 5.18957 18.0428 5.21351 18.0126 5.24626Z"
          fill={color}
        />
        <path
          d="M15.9633 8.66648C16.0962 8.94738 16.22 9.24673 16.2303 9.56145C16.2409 9.88612 16.124 10.2022 15.9795 10.4878C15.9156 10.6139 15.8446 10.736 15.7707 10.8565C15.7296 10.9238 15.74 10.9901 15.835 10.9762C16.0849 10.9398 16.3323 10.8163 16.5338 10.6683C17.0231 10.3089 17.2977 9.72608 17.2649 9.11974C17.2307 8.48655 16.8709 7.98371 16.4288 7.55921C16.2503 7.38778 16.0527 7.23807 15.8788 7.06143C15.4264 6.60235 15.1138 6.01896 15.156 5.35976C15.1913 4.80559 15.4527 4.23658 15.8157 3.81943C15.8476 3.7837 15.8191 3.7248 15.7706 3.7287C15.7494 3.73038 15.7307 3.74767 15.7147 3.75968C15.6456 3.8117 15.5794 3.8677 15.5156 3.92599C15.3681 4.06086 15.2348 4.20927 15.1161 4.37008C14.8634 4.71211 14.6849 5.11106 14.6223 5.53326C14.4956 6.38631 14.8729 7.18222 15.4069 7.82375C15.6252 8.08622 15.816 8.35543 15.9633 8.66648Z"
          fill={color}
        />
        <path
          d="M12 0C5.38316 0 0 5.38316 0 12C0 18.6168 5.38316 23.9999 12 23.9999C18.6168 23.9999 23.9999 18.6168 23.9999 12C23.9999 5.38316 18.6168 0 12 0ZM22.185 12C22.185 14.4819 21.2922 16.759 19.8115 18.5279L15.9077 14.6243H16.7391C17.0385 14.6243 17.2812 14.3816 17.2812 14.0822V12.2757C17.2812 11.9763 17.0385 11.7336 16.7391 11.7336H15.0086V13.7252L14.2228 12.9395V11.7336H13.0169L5.47175 4.18876C7.24074 2.70787 9.51791 1.81497 12 1.81497C17.616 1.81497 22.185 6.38393 22.185 12ZM1.81497 12C1.81497 9.51807 2.7078 7.24097 4.18846 5.47205L10.4501 11.7336H5.49745C5.19811 11.7336 4.95537 11.9763 4.95537 12.2757V14.0822C4.95537 14.3816 5.19811 14.6243 5.49745 14.6243H13.3409L18.5281 19.8113C16.7591 21.2921 14.4821 22.185 12 22.185C6.38393 22.185 1.81497 17.616 1.81497 12Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_2364_4031">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
